import {MithrilComponent} from '@bitstillery/mithril'
import {classes} from '@bitstillery/common/lib/utils'
import {FieldCheckbox} from '@bitstillery/common/components'
import type {CollectionColumnSetup, CollectionProxy, CollectionRow} from '@bitstillery/common/lib/collection'
import {grid_columns} from '@bitstillery/common/lib/collection'
import m from '@bitstillery/mithril'

interface CollectionColumnsAttrs {
    /** `never`: only the column names and widths are read here, so any collection's columns will do. */
    columns: CollectionColumnSetup<never>
    collection: CollectionProxy
    has_selection?: boolean
}

export class CollectionColumns extends MithrilComponent<CollectionColumnsAttrs> {
    view(vnode: m.Vnode<CollectionColumnsAttrs>) {
        let {has_selection} = vnode.attrs

        const {selection} = vnode.attrs.collection.state
        has_selection = ['select', 'select_visible', 'deselect'].includes(selection.mode)

        const grid_template_cols = grid_columns(vnode.attrs.columns, has_selection, vnode.attrs.collection.state.bulk_mode)
        return (
            <div className={classes('c-collection-columns', 'c-collection-items')}>
                <div className='item'>
                    <div className='cells' style={`grid-template-columns: ${grid_template_cols}`}>
                        <div className='cell'>
                            {has_selection && (
                                <FieldCheckbox
                                    computed={(): boolean | void => {
                                        if (vnode.attrs.collection.state.selection.mode === 'select_visible') {
                                            const all_checked = vnode.attrs.collection.state.items.every((item: CollectionRow) =>
                                                vnode.attrs.collection.state.selection.ids.includes(item.artkey),
                                            )
                                            return all_checked
                                        } else if (vnode.attrs.collection.state.selection.mode === 'select') {
                                            if (vnode.attrs.collection.state.selection.all) {
                                                return vnode.attrs.collection.state.selection.ids.length === 0
                                            }
                                            return vnode.attrs.collection.state.items.every((item: CollectionRow) =>
                                                vnode.attrs.collection.state.selection.ids.includes(item.artkey),
                                            )
                                        }
                                    }}
                                    disabled={vnode.attrs.collection.state.loading}
                                    // model={[vnode.attrs.collection.state.selection, 'all']}
                                    onclick={() => {
                                        if (vnode.attrs.collection.state.selection.mode === 'select') {
                                            vnode.attrs.collection.state.selection.all =
                                                !vnode.attrs.collection.state.selection.all
                                        } else if (vnode.attrs.collection.state.selection.mode === 'select_visible') {
                                            const all_checked = vnode.attrs.collection.state.items.every((item: CollectionRow) =>
                                                vnode.attrs.collection.state.selection.ids.includes(item.artkey),
                                            )
                                            if (all_checked) {
                                                vnode.attrs.collection.state.selection.ids.splice(
                                                    0,
                                                    vnode.attrs.collection.state.selection.ids.length,
                                                )
                                            } else {
                                                vnode.attrs.collection.state.selection.ids.splice(
                                                    0,
                                                    vnode.attrs.collection.state.items.length,
                                                    ...vnode.attrs.collection.state.items.map((i: CollectionRow) => i.artkey),
                                                )
                                            }
                                        }
                                    }}
                                />
                            )}
                        </div>
                        {vnode.attrs.columns.map((column) => (
                            <div className={classes('cell', column.className, 'cell-type-default')}>
                                {typeof column.name === 'function' ? column.name() : column.name}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        )
    }
}
